export default __webpack_public_path__ + "static/media/flag-pt-PT.355dd853.png";